import Footer from "../components/ui/footer";
import Header from "../components/ui/header";
import React from "react";
import DemoVideoPt from "../demo/demo-video-pt";

export default function DemoPt() {
    return (
        <div>
            <Header />
            <DemoVideoPt />
            <Footer />
        </div>
    );
}